import { render, staticRenderFns } from "./FooterContact.vue?vue&type=template&id=61fdbefd&scoped=true&"
import script from "./FooterContact.vue?vue&type=script&lang=js&"
export * from "./FooterContact.vue?vue&type=script&lang=js&"
import style0 from "./FooterContact.vue?vue&type=style&index=0&id=61fdbefd&scoped=true&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "61fdbefd",
  null
  
)

export default component.exports